import styled from "styled-components";

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  padding: 1.5rem 0;
  position: relative;
  top: 7rem;
  width: 100%;

  .footerContainer {
    position: relative;
    top: 0;
    min-height: 10vh;
    width: 90%;
  }
  .subtitle {
    width: 100%;
  }
  .content {
    width: 75%;
  }
  .image {
    height: 5rem;
    width: 25%;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  @media screen and (min-width: 1024px) {
    .footerContainer {
      width: 100%;

      .subtitle {
        width: 100%;
      }
      .image {
        height: 10rem;
        width: 10rem;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
`;
